import React, { useEffect, useMemo, useRef, useState } from "react";
import "./SocialMedia.css";

const Facebook = ({ facebookLink }) => {
  const containerRef = useRef(null);
  const [pluginWidth, setPluginWidth] = useState(500);

  useEffect(() => {
    const element = containerRef.current;

    if (!element) {
      return undefined;
    }

    const updateWidth = () => {
      const nextWidth = Math.min(Math.max(Math.round(element.clientWidth), 180), 500);
      setPluginWidth((currentWidth) =>
        currentWidth === nextWidth ? currentWidth : nextWidth
      );
    };

    updateWidth();

    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", updateWidth);

      return () => {
        window.removeEventListener("resize", updateWidth);
      };
    }

    const observer = new ResizeObserver(updateWidth);
    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, []);

  const pluginUrl = useMemo(
    () =>
      `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(
        facebookLink
      )}&tabs=timeline&width=${pluginWidth}&height=720&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&mobile_iframe=true`,
    [facebookLink, pluginWidth]
  );

  return (
    <div className="social-media-container">
      <h3 className="social-media-title">Follow us on Facebook</h3>
      <div className="social-media-frameWrap" ref={containerRef}>
        <iframe
          key={pluginWidth}
          title="Facebook timeline"
          className="social-media-iframe"
          src={pluginUrl}
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
          scrolling="no"
        />
      </div>
    </div>
  );
};

export default Facebook;
